module.exports = __webpack_public_path__ + "src/assets/img/icon_user_default.png";